import { Inject, Injectable } from "@angular/core";
import { AppType, APP_TYPE } from "../app.type";
import { ReleaseNotesBannerServiceType } from "./release-notes-banner.service.type";
import { environment } from "../../environments/environment";
import { updateProfileReleaseVersion } from "../api.service";
import { BehaviorSubject } from "rxjs";
import { StringUtils } from "../../../../shared/utils/string.utils";
import { Customer } from "../../../../shared/types/customers";
import { TOKEN } from "../auth/token";

@Injectable({
  providedIn: "root",
})
export class ReleaseNotesBannerService
  implements ReleaseNotesBannerServiceType
{
  bannerSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(@Inject(APP_TYPE) private app: AppType) {}

  async handleReleaseNotesBanner(customer: Customer) {
    if (
      customer != Customer.OMP &&
      !StringUtils.isNullOrEmpty(localStorage.getItem(TOKEN)) &&
      localStorage.getItem("lastVersionSeen") !== environment.version
    ) {
      this.bannerSubject.next(true);
    } else {
      this.bannerSubject.next(false);
    }
  }

  async updateProfile() {
    if (
      this.app.profile.ownProfile.releaseVersions == null ||
      !this.app.profile.ownProfile.releaseVersions.includes(environment.version)
    ) {
      await updateProfileReleaseVersion(environment.version);
      this.bannerSubject.next(false);
    }
  }

  openReleaseNotesModal() {
    this.bannerSubject.next(false);
    this.app.releaseNotesModal.open(true);
  }
}
